import { useMemo, useState } from 'react'
import PriceHistoryModal from '../components/PriceHistoryModal'
import './PriceHistoryGallery.css'

const NOW = Date.parse('2026-09-15T10:00:00.000Z')
const DAY = 24 * 60 * 60 * 1000
const LONG_NAME = 'Casque audio sans fil à réduction de bruit active avec étui de charge et câble USB-C de remplacement inclus'

function iso(offsetDays, hour = 10) {
  return new Date(NOW - offsetDays * DAY + hour * 3600000).toISOString()
}

const FIXTURES = {
  loading: {
    item: { id: 'sim-loading', name: LONG_NAME, image_url: '/Icon shopping cart.png' },
    preview: { loading: true },
  },
  error: {
    item: { id: 'sim-error', name: LONG_NAME, image_url: '/Icon shopping cart.png' },
    preview: { error: { response: { status: 503, data: { detail: 'Réseau indisponible' } } } },
  },
  forbidden: {
    item: { id: 'sim-forbidden', name: 'Produit inaccessible', image_url: '/Icon shield.png' },
    preview: { error: { response: { status: 403 } } },
  },
  empty: {
    item: { id: 'sim-empty', name: 'Théière en fonte', image_url: '/Icon local offer.png' },
    preview: { data: { item_id: 'sim-empty', history: [], count: 0 } },
  },
  single: {
    item: { id: 'sim-single', name: 'Lampe de bureau articulée', image_url: '/Icon bolt.png' },
    preview: {
      data: {
        item_id: 'sim-single',
        history: [{ id: 'p1', price: 64.9, checked_at: iso(2), currency: 'EUR' }],
        count: 1,
      },
    },
  },
  multiple: {
    item: { id: 'sim-multi', name: LONG_NAME, image_url: '/Icon query stats.png' },
    preview: {
      data: {
        item_id: 'sim-multi',
        history: [
          { id: 'a', price: 129, checked_at: iso(80), currency: 'EUR' },
          { id: 'b', price: 0, checked_at: iso(40), currency: 'EUR' },
          { id: 'c', price: 'n/a', checked_at: iso(21), currency: 'EUR' },
          { id: 'd', price: 119.9, checked_at: iso(18), currency: 'EUR' },
          { id: 'dup', price: 118.5, checked_at: iso(18), currency: 'EUR' },
          { id: 'e', price: 112, checked_at: iso(9), currency: 'EUR' },
          { id: 'f', price: 108.4, checked_at: iso(3), currency: 'EUR' },
          { id: 'g', price: 99.99, checked_at: iso(0.2), currency: 'EUR' },
        ],
        count: 8,
      },
    },
  },
}

const STATES = [
  ['loading', 'Chargement'],
  ['error', 'Erreur réseau'],
  ['forbidden', 'Accès refusé'],
  ['empty', 'Aucun relevé'],
  ['single', 'Un point'],
  ['multiple', 'Plusieurs points'],
]

export default function PriceHistoryGallery() {
  const [state, setState] = useState('multiple')
  const [open, setOpen] = useState(true)
  const fixture = FIXTURES[state]
  const cards = useMemo(
    () => Array.from({ length: 12 }, (_, index) => ({
      id: index,
      name: index === 0 ? LONG_NAME : `Carte produit ${index + 1}`,
      price: `${(19 + index * 7).toFixed(2)} €`,
    })),
    [],
  )

  return (
    <div className="price-history-gallery">
      <div className="price-history-gallery-bar">
        {STATES.map(([id, label]) => (
          <button
            key={id}
            type="button"
            className={state === id ? 'is-active' : ''}
            onClick={() => {
              setState(id)
              setOpen(true)
            }}
          >
            {label}
          </button>
        ))}
      </div>
      <div className="price-history-gallery-grid">
        {cards.map((card) => (
          <article key={card.id} className="price-history-gallery-card">
            <strong>{card.name}</strong>
            <span>{card.price}</span>
            <p>Texte volontairement visible pour contrôler l’opacité de la fenêtre.</p>
          </article>
        ))}
      </div>
      <PriceHistoryModal
        isOpen={open}
        onClose={() => setOpen(false)}
        itemId={fixture.item.id}
        itemName={fixture.item.name}
        itemImage={fixture.item.image_url}
        preview={fixture.preview}
      />
    </div>
  )
}
